export default __webpack_public_path__ + "static/media/UsersPlaceholder.688e079b.png";